import { CreateLegalClientBranchParams } from 'api/types/params';
import {
  parseBaseStateRegistrationParam,
  parseCompanyTaxResidencyParam,
  parseCompanyAddressParam,
} from 'modules/client/common/helpers';

import { LegalClientBranchFormType } from '../../forms/legalClientBranchForm';

export const getLegalClientBranchSubmitData = (
  legalClientId: string,
  versionNumber: number,
  values: LegalClientBranchFormType
): CreateLegalClientBranchParams => {
  const addressParam = parseCompanyAddressParam(values);

  return {
    versionNumber,
    reason: values.reasonChange.reason,
    legalClientId,
    fullName: values.branchName.fullName,
    legalAddress: addressParam.legalAddress,
    actualAddress: addressParam.actualAddress,
    email: values.contacts.email ?? null,
    phone: values.contacts.phone ?? null,
    stateRegistration: parseBaseStateRegistrationParam(values),
    taxResidences: parseCompanyTaxResidencyParam(values),
  };
};
